'use client';
import { ArrowUp, Paperclip } from 'lucide-react';
import { useState } from 'react';
import styles from './FloraInputArea.module.css';
import { RocketLaunch } from '@mui/icons-material';

export interface FloraInputAreaProps {
	onSend?: (message: string) => void;
	onAttach?: () => void;
	onDeepThink?: () => void;
}

export const FloraInputArea = ({ onSend, onAttach, onDeepThink }: FloraInputAreaProps) => {
	const [message, setMessage] = useState('');

	const handleSend = () => {
		if (message.trim() && onSend) {
			onSend(message);
			setMessage('');
		}
	};

	const handleKeyDown = (e: React.KeyboardEvent) => {
		if (e.key === 'Enter' && !e.shiftKey) {
			e.preventDefault();
			handleSend();
		}
	};

	return (
		<div className={styles.container}>
			<div className={styles.inputWrapper}>
				<input
					type="text"
					value={message}
					onChange={(e) => setMessage(e.target.value)}
					onKeyDown={handleKeyDown}
					placeholder="O que mudou entre a análise de maio e a de janeiro?"
					className={styles.input}
					aria-label="Digite sua mensagem"
					autoComplete="off"
					autoCorrect="on"
					autoCapitalize="sentences"
					spellCheck
					inputMode="text"
					enterKeyHint="send"
				/>
				<button
					className={styles.sendButton}
					onClick={handleSend}
					type="button"
					disabled={!message.trim()}
					aria-label="Enviar mensagem"
				>
					<ArrowUp size={18} strokeWidth={2.5} />
				</button>
			</div>

			<div className={styles.actions}>
				<button className={styles.actionButton} onClick={onAttach} type="button">
					<Paperclip strokeWidth={2} className={styles.icon} />
					<span>Anexar</span>
				</button>
				<button className={styles.actionButton} onClick={onDeepThink} type="button">
					<RocketLaunch strokeWidth={2} className={styles.icon} />
					<span>Deep Think</span>
				</button>
			</div>
		</div>
	);
};
